import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import { useNavigate, Link } from 'react-router-dom';

const OrderDetails = () => {
  const { id } = useParams(); // Get order ID from URL parameters
  const [order, setOrder] = useState({
    cart: [],
    delivery_address: '',
    email: '',
    firstname: '',
    lastname: '',
    orderDate: null,
    phone: '',
    selectedCountry: '', // Initialize as empty string or default value
    state: '', // Ensure you're using the correct key name
    note: '',
    total: 0
  });

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const orderDoc = await getDoc(doc(db, 'Orders', id)); // Reference to the specific order
        
        if (orderDoc.exists()) {
          const orderData = orderDoc.data();
          setOrder(orderData);
          console.log(orderData);
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching order: ', error);
      }
    };

    fetchOrder();
  }, [id]);

  if (!order) return <div>Loading...</div>;

  // Destructure the order object
  const {
    firstname = 'N/A',
    lastname = 'N/A',
    email = 'N/A',
    phone = 'N/A',
    delivery_address = 'N/A',
    selectedCountry = '',
    state = '', // Correct key name
    note ='',
    total = 0,
    orderDate = new Date(),
    cart = []
  } = order;

  // Format the order date, ensure it's a valid date object
  const formattedOrderDate = orderDate
    ? new Date(orderDate.seconds * 1000).toLocaleString()
    : 'Date not available';

  // Ensure selectedCountry is a string or extract value if it's an object
  const displayCountry = typeof selectedCountry === 'object' 
    ? selectedCountry.label || 'Country not available'
    : selectedCountry || 'Country not available';

 // Ensure state is a string or extract value if it's an object
 const displayState = state && typeof state === 'object'
 ? state.label || 'State not available'
 : state || 'State not available';
  return (
    <>
      <PageTitle title="Order - ALMOSTINVISIBLE" />
      <Layout>
        <div className="container mt-5">
          
          <div className="d-flex justify-content-between">
                <h1 className='unbounded'>Order Details</h1>
          
                
          </div>
          
          
          <div className='row gx-3 mt-5'>
            <div className="col-md-6">
                <h4 className="unbounded" style={{textDecoration: "underline"}}>
                    Shipping details
                </h4>
                <p><strong>Order ID:</strong> {id}</p>
                <p><strong>First Name:</strong> {firstname}</p>
                <p><strong>Last Name:</strong> {lastname}</p>
                <p><strong>Email:</strong> {email}</p>
                <p><strong>Phone:</strong> {phone}</p>
                <p><strong>Delivery Address:</strong> {delivery_address}</p>
                <p><strong>Country:</strong> {displayCountry}</p>
                <p><strong>State:</strong> {displayState}</p>

                <p><strong>Note from shopper:</strong> {note}</p>

                <p><strong>Total:</strong> NGN {total.toFixed(2)}</p>
                <p><strong>Order Date:</strong> {formattedOrderDate}</p>
            </div>
            <div className="col-md-6">
                <h4 className='unbounded' style={{textDecoration: "underline"}} >What The Shopper Ordered</h4>
                <ol >
                    {Array.isArray(cart) && cart.length > 0 ? (
                        cart.map((item, index) => (
                        <li key={index} className='d-flex justify-content-between'>

                            <div>
                                <span className='h5 fw-bold'>{index +1}. &nbsp;</span>
                                <img src={item.images[0]} alt="" srcset="" width="70" height="70" />
                                
                            </div>
                            
                            <div className="d-flex flex-column" style={{marginRight: "10vw"}}>
                                <span className='fw-bold'>
                                    ID - #{item.id || 'N/A'}
                                </span>
                                <span className='fw-bold'>
                                    Name - {item.name || 'Item name not available'}
                                </span> 
                                <span className='fw-bold'>
                                    Quantity - X{item.quantity || 'N/A'}
                                </span>
                                <span className='fw-bold'>
                                    Color - {item.color || 'N/A'}
                                </span>
                                <span className='fw-bold'>
                                    Size - {item.size || 'N/A'}
                                </span>
                                <span className='fw-bold'>
                                    Price - NGN {item.price || 'N/A'} each
                                </span>

                        
                                <Link to={`/p/${item.id}`} className="black-button">
                                    View Product
                                </Link>
                            </div>
                            <hr />
                        </li>
                        ))
                    ) : (
                        <li>No items was ordered</li>
                    )}
                </ol>
            </div>
            
          </div>
        </div>
      </Layout>
    </>
  );
};

export default OrderDetails;
